import { calendarSettingsColumns, focusOutline } from 'shared/assets/styles';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  ${calendarSettingsColumns};
`;

export const Body = styled.div`
  grid-column: span 3;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  min-width: 0;
`;

export const RemoveCell = styled.span`
  grid-column: 6;
  display: flex;
`;

export const IconContainer = styled.span`
  line-height: 62.5%;
  font-size: 1.6rem;
`;

export const Info = styled.div`
  display: grid;
  min-width: 0;
`;

export const EmailRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  min-width: 0;
`;

export const Email = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ContactsWarningButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  padding: 0;
  border: none;
  background: none;
  cursor: pointer;

  color: ${({ theme }) => theme.palette.warning.main};
  font-size: 1.4rem;
  line-height: 1;

  &:focus-visible {
    ${focusOutline};
  }
`;

export const BrokenMessage = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.caption)};
  color: ${({ theme }) => theme.palette.error.main};
`;

export const ContactsNotice = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-top: ${({ theme }) => theme.spacing(1)};
`;

export const ContactsNoticeIcon = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  color: ${({ theme }) => theme.palette.warning.main};
  font-size: 1.4rem;
  line-height: 1;
`;

export const ContactsNoticeMessage = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  color: ${({ theme }) => theme.palette.text.secondary};
  flex: 1;
  min-width: 0;
`;

export const DialogHeader = styled.div`
  padding: ${({ theme }) => `${theme.spacing(5)} ${theme.spacing(6)}`};
`;

export const DialogBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(8)};

  padding: ${({ theme }) => `0 ${theme.spacing(6)}`};
`;

export const DialogFooter = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: flex-end;

  padding: ${({ theme }) => `${theme.spacing(5)} ${theme.spacing(6)}`};
`;
